import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import getApiBaseUrl from '@/utils/getBaseUrl';

export default function useGetReports() {
  const { isAuthenticated } = useAuth0();
  const token = window.localStorage.getItem('_token');

  return useQuery({
    queryKey: ['REPORTS'],
    queryFn: async () => {
      const response = await fetch(`${getApiBaseUrl()}/api/v1/reports`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data.data;
    },
    enabled: isAuthenticated && !!token,
  });
}
